var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkCompleted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "10px",
    viewBox: "0 0 14 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Resourch",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.07110596,7.99591064 L9.07110596,-2.77172852 C9.07110596,-3.18594208 9.40689239,-3.52172852 9.82110596,-3.52172852 C10.2353195,-3.52172852 10.571106,-3.18594208 10.571106,-2.77172852 L10.571106,8.72827148 C10.571106,8.87256513 10.5303577,9.00734152 10.4597407,9.12172115 C10.3299472,9.34544962 10.0878181,9.49591064 9.81054688,9.49591064 L4.31054688,9.49591064 C3.89633331,9.49591064 3.56054688,9.16012421 3.56054688,8.74591064 C3.56054688,8.33169708 3.89633331,7.99591064 4.31054688,7.99591064 L9.07110596,7.99591064 Z",
    id: "icon-mark",
    fill: "#6D7A90",
    fillRule: "nonzero",
    transform: "translate(7.065826, 2.987091) rotate(-315.000000) translate(-7.065826, -2.987091) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkCompleted);
export default __webpack_public_path__ + "static/media/mark-completed.6a6ac83e885a930a13a4f845d401a957.svg";
export { ForwardRef as ReactComponent };